import { fromJS } from "immutable";
import * as actionTypes from './actionTypes'

const initialState = fromJS({
  accountData: {
    isLoading: true,
    data: {},
    error: ""
  },
  recentTabData: {
    isLoading: true,
    data: {},
    error: ""
  },
  recurringTabData: {
    isLoading: true,
    data: {},
    error: ""
  }
});
const investmentDashboard = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.investmentDashboardDataSuccessType:
      return state
        .setIn(["accountData", "data"], action.payload)
        .setIn(["accountData", "isLoading"], false);

    case actionTypes.investmentDashboardDataLoaderType:
      return state.setIn(["accountData", "isLoading"], true);

    case actionTypes.recentExchangeDataSuccessType:
      return state
        .setIn(
          ["recentTabData", "data"],
          action.payload
        )
        .setIn(
          ["recentTabData", "isLoading"],false);

    case actionTypes.recentExchangeDataLoaderType:
          return state.setIn(["recentTabData", "isLoading"],true);

    case actionTypes.recurringExchangeDataSucessType:
      return state
        .setIn(
          ["recurringTabData", "data"],
          action.payload.recurringExchanges.exchanges
        )
        .setIn(
          ["recurringTabData", "isLoading"],false);
          
     case actionTypes.recurringExchangeDataLoaderType:
          return state.setIn(["recurringTabData", "isLoading"],true)
    default:
      return state;
  }
};

export default investmentDashboard;
